import { ButtonV2, Flex, styled } from '@withjoy/joykit';

export const StyledMainContainer = styled(Flex)`
  align-items: center;
`;

export const StyledBreadcrumbContainer = styled(Flex)<{ isMobile?: boolean; defaultAlign?: string }>`
  font-family: 'Inter UI';
  font-style: normal;
  font-weight: 400;
  text-align: left;
  background: white;
  justify-content: ${props => props.defaultAlign};
  ${props =>
    props.isMobile
      ? `
      font-size: 13px;
      line-height: 18px;
      letter-spacing: -0.02em;
      justify-content: left;
      color: ${props.theme.colors.typeTertiaryDark};
      `
      : `
        width: 100%;
        -webkit-backdrop-filter: blur(32px);
        -webkit-filter: saturate(1.2);
        backdrop-filter: blur(32px);
        filter: saturate(1.2);
        font-size: 17px;
        line-height: 24px;
        letter-spacing: -0.0001em;
        color: ${props.theme.colors.mono14};


        &.fixed-top {
          position: fixed;
          height: 56px;
          justify-content: left;
          top: 0px;
          left: 0px;
          z-index: 10;
          background: rgba(255, 255, 255, 0.8);
          align-items: center;
        }
  `};
`;

export const StyledBreadcrumb = styled.span<{ allowNavigationOnCurrentPage?: boolean }>`
  font-weight: 600;
  transition: color 0.8s;
  &.current-page {
    color: ${props => (props.allowNavigationOnCurrentPage ? props.theme.colors.mono14 : props.theme.colors.mono10)};
    &:hover {
      cursor: ${props => (props.allowNavigationOnCurrentPage ? 'pointer' : 'default')};
      color: ${props => (props.allowNavigationOnCurrentPage ? props.theme.colors.buttonPrimaryHover : props.theme.colors.mono10)};
    }
  }
  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.buttonPrimaryHover};
  }
`;

export const StyledSlash = styled.span<{ isMobile?: boolean }>`
  ${props =>
    props.isMobile
      ? `
      margin: 0 4px;
      `
      : `
      margin: 0 16px;
  `}

  color: ${props => props.theme.colors.mono5};
`;

export const StyledBackButton = styled(ButtonV2)`
  svg {
    height: 12px;
  }
  &:hover {
    cursor: default;
  }
`;
